import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useApiError from 'packages/novous_web/src/api/useApiError';
import React, { useRef, useEffect, useState } from 'react';
import VideoOverlay from './VideoOverlay';
import useAxios from 'packages/novous_web/src/api/useAxios';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { height, width } from '@mui/system';
import { set } from 'react-datepicker/dist/date_utils';

type VideoPlayerProps = {
  availableHeight: number;
  availableWidth: number;
  key?: number;
  streamUrl: string; // For MP4 files
  customerId?: any;
  controls?: boolean;
  duration?: number;
  playing?: boolean;
  cameraId?: string;
  cameraList?: any;
  deviceId?: string;
  sdVideo?: boolean;
  fullMode?: boolean;
  singleFullMode?: boolean;
  mlParams?: any;
  isRounded?: boolean;
  isDriverCoachingVideos?: boolean;
  deviceType?: string
};

const MP4VideoPlayer: React.FC<VideoPlayerProps> = ({
  availableHeight,
  availableWidth,
  key = 0,
  streamUrl,
  customerId,
  cameraList,
  playing = true,
  duration = 0,
  controls = false,
  cameraId,
  deviceId,
  sdVideo,
  fullMode,
  singleFullMode,
  mlParams,
  isRounded,
  isDriverCoachingVideos = false,
  deviceType
}) => {
  const playerRef = useRef<HTMLVideoElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Maintain aspect ratio (16:9)
  const aspectRatio = 16 / 9;

  // Fit the video fully inside the available height and width (contain logic)
  const heightBasedWidth = availableHeight * aspectRatio;
  const widthBasedHeight = availableWidth / aspectRatio;
  const [overlayReady, setOverlayReady] = useState(false);
  const [playerSize, setPlayerSize] = useState({ width: 0, height: 0 });
  const [blurStatus, setBlurStatus] = useState<boolean>(false);
  const [VideoReady, setVideoReady] = useState<boolean>(true);
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });

  const [videoLoaded, setVideoLoaded] = useState(false);
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);


  const {
    data: downloadData,
    error: downloadError,
    loading: downloadLoading,
    fetchData: fetchDownload,
  } = useAxios(API_ENDPOINTS.videoBlur.BLUR_VIDEO_PROCESSING, "POST", "blob");

  useEffect(() => {
    console.log(overlayReady, 'overlayReady yashxx useEffect 55');

  }, [overlayReady])

  useEffect(() => {
    console.log('overlayReady yashxx initlall 60', overlayReady);

  }, [])

  // useEffect(() => {
  //   if (!overlayReady) return;

  //   const updateSize = () => {
  //     if (playerRef.current) {
  //       const rect = playerRef.current.getBoundingClientRect();
  //       setPlayerSize({ width: rect.width, height: rect.height });
  //     }
  //   };

  //   updateSize(); // initial call

  //   const resizeObserver = new ResizeObserver(() => updateSize());
  //   if (playerRef.current) {
  //     resizeObserver.observe(playerRef.current);
  //   }

  //   return () => {
  //     if (playerRef.current) {
  //       resizeObserver.unobserve(playerRef.current);
  //     }
  //   };
  // }, [overlayReady, playerRef.current]);

  useEffect(() => {
    if (!overlayReady) return;

    const updateSize = () => {
      const ref = playerRef.current || imageRef.current;
      if (ref) {
        const rect = ref.getBoundingClientRect();
        setPlayerSize({ width: rect.width, height: rect.height });
      }
    };

    updateSize();

    const resizeObserver = new ResizeObserver(() => updateSize());

    if (playerRef.current) {
      resizeObserver.observe(playerRef.current);
    } else if (imageRef.current) {
      resizeObserver.observe(imageRef.current);
    }

    return () => {
      if (playerRef.current) {
        resizeObserver.unobserve(playerRef.current);
      } else if (imageRef.current) {
        resizeObserver.unobserve(imageRef.current);
      }
    };
  }, [overlayReady, playerRef.current, imageRef.current]);


  const normalizedCameraId = cameraId === "02" && deviceType === "vp2" ? "04" : cameraId;

  useEffect(() => {
    if (!normalizedCameraId || normalizedCameraId !== "04") {
      console.log('Making overlayReady true yashxx 89');
      setOverlayReady(true); // Default ready if no overlay is required
    }
  }, [normalizedCameraId, cameraList]);


  useEffect(() => {
    if (playerRef.current && overlayReady && playing) {
      playerRef.current.play().catch((error) => console.error("Video playback error:", error));
    }
    if (isDriverCoachingVideos && playerRef.current) {
      playerRef.current.pause();
    }
  }, [overlayReady, playing, playerRef.current]);

  let finalWidth: number;
  let finalHeight: number;

  if (heightBasedWidth <= availableWidth) {
    // Height is the limiting factor
    finalHeight = availableHeight;
    finalWidth = heightBasedWidth;
  } else {
    // Width is the limiting factor
    finalWidth = availableWidth;
    finalHeight = widthBasedHeight;
  }

  // useEffect(() => {
  //   if (!cameraId || cameraId == "04") {
  //     console.log('Making overlayReady false yashxx 110');
  //     setOverlayReady(false)
  //   }

  // }, [finalHeight, finalWidth, cameraList])

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.style.width = `${finalWidth}px`;
      playerRef.current.style.height = `${finalHeight}px`;
      playerRef.current.style.objectFit = 'contain'; // Ensures full video is visible
    }
  }, [finalWidth, finalHeight]);

  console.log(streamUrl, finalHeight, finalWidth, 'streamUrl ------------------------');

  const {
    data: mlParamsData,
    error: mlParamsError,
    loading: mlParamsLoading,
    fetchData: mlParamsRequestData,
  } = useApiError<any>(`${API_ENDPOINTS.videoBlur.BLUR_CROPPED_VIDEO}/${deviceId}`, "GET"
  );

  const handleBlurStatus = (blurStatus: boolean) => {
    console.log('handleBlurStatus called');
    setVideoReady(blurStatus)
    setBlurStatus(blurStatus)
  }

  useEffect(() => {
    if (mlParamsError) {
      setToast({ open: true, message: 'Error while fetching ML Params', type: 'error' });
    }
  }, [mlParamsError])

  useEffect(() => {
    if (blurStatus && streamUrl) {
      mlParamsRequestData(deviceId);
    }
  }, [blurStatus, streamUrl])

  // const staticMlParams = {
  //     data: {
  //         data: {
  //             dsmCabin: {
  //                 dsm_cabin_driver_crop_height: 169,
  //                 dsm_cabin_driver_crop_width: 250,
  //                 dsm_cabin_driver_crop_x: 172,
  //                 dsm_cabin_driver_crop_y: 90
  //             },
  //         },
  //     },
  // };

  mlParams = mlParamsData;

  const [internalPlaying, setInternalPlaying] = useState(playing);

  useEffect(() => {
    setInternalPlaying(playing);
  }, [playing]);

  useEffect(() => {
    if (!playerRef.current) return;
    if (internalPlaying) playerRef.current.play().catch(() => { });
    else playerRef.current.pause();
  }, [internalPlaying]);

  const togglePlayPause = () => setInternalPlaying((prev) => !prev);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.fullscreenElement || document.fullscreenElement || document.fullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  const fullModeWidth = window.innerWidth;
  const fullModeHeight = window.innerHeight;


  if (fullMode) {
    if (fullModeHeight * aspectRatio <= fullModeWidth) {
      finalHeight = fullModeHeight;
      finalWidth = fullModeHeight * aspectRatio;
    } else {
      finalWidth = fullModeWidth;
      finalHeight = fullModeWidth / aspectRatio;
    }
  } else {
    if (heightBasedWidth <= availableWidth) {
      finalHeight = availableHeight;
      finalWidth = heightBasedWidth;
    } else {
      finalWidth = availableWidth;
      finalHeight = widthBasedHeight;
    }
  }

  const [showLoader, setShowLoader] = useState(false);
  const [pendingDownload, setPendingDownload] = useState(false);


  useEffect(() => {
    if (pendingDownload && downloadData && downloadData instanceof Blob) {
      const url = window.URL.createObjectURL(downloadData);
      const a = document.createElement('a');
      a.href = url;
      a.download = `video_${deviceId || 'download'}.mp4`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setShowLoader(false);
      setToast({ open: true, message: 'Download started', type: 'success' });
      setPendingDownload(false);
    } else if (pendingDownload && downloadError) {
      setShowLoader(false);
      setToast({ open: true, message: 'Error while downloading video', type: 'error' });
      setPendingDownload(false);
    }
  }, [pendingDownload, downloadData, downloadError, deviceId]);


  const handleCustomDownload = async () => {
    try {
      setShowLoader(true);
      if (!blurStatus) {
        // Direct download
        try {
          const response = await fetch(streamUrl, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "include",
            headers: {
              'Origin': 'https://new.novusomnifleet.com'
            }
          });
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;

          // Extract filename extension from streamUrl
          const extension = streamUrl.split('?')[0].split('.').pop()?.toLowerCase();

          // Use proper file type based on extension
          const isVideo = extension === 'mp4' || extension === 'webm' || extension === 'mov';
          const isImage = extension === 'jpg' || extension === 'jpeg' || extension === 'png';

          let filename = 'file_download';

          if (isVideo) {
            filename = `video_${deviceId || 'download'}.${extension}`;
          } else if (isImage) {
            filename = `image_${deviceId || 'download'}.${extension}`;
          }

          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();

          window.URL.revokeObjectURL(url);
          setShowLoader(false);
          setToast({ open: true, message: 'Download started', type: 'success' });
        } catch (error) {
          setShowLoader(false);
          setToast({ open: true, message: 'Error while downloading', type: 'error' });
        }
        return;
      }
      setToast({ open: true, message: 'processing video...', type: 'info' });
      setPendingDownload(true);
      const payload = {
        videoUrl: streamUrl,
        x: mlParams?.data?.data?.dsmCabin?.dsm_cabin_driver_crop_x ?? 0,
        y: mlParams?.data?.data?.dsmCabin?.dsm_cabin_driver_crop_y ?? 0,
        width: mlParams?.data?.data?.dsmCabin?.dsm_cabin_driver_crop_width ?? 0,
        height: mlParams?.data?.data?.dsmCabin?.dsm_cabin_driver_crop_height ?? 0
      };
      await fetchDownload(payload); // This should return the blob
    } catch (error) {
      setShowLoader(false);
      setToast({ open: true, message: 'Error while downloading video', type: 'error' });
    }
  };

  console.log(overlayReady, 'overlayReady yashxx 181', deviceType);
  console.log('streamurl shresth', streamUrl.split('?')[0].toLowerCase().endsWith('.jpg'));
  return (
    <>
      <div
        className="flex items-center justify-center text-white"
        style={{
          width: isFullscreen ? '100vw' : '100%',
          height: isFullscreen ? '100vh' : finalHeight,
          position: isFullscreen ? 'fixed' : 'relative',
          left: '0',
          top: '0',
          bottom: '0',
          right: '0',
          flexDirection: 'column',
        }}
      >
        {normalizedCameraId === "04" && (
          <VideoOverlay
            deviceId={deviceId}
            customerId={customerId}
            streamUrl={streamUrl}
            sdVideo={sdVideo}
            fullMode={fullMode}
            singleFullMode={singleFullMode}
            setBlurStatus={handleBlurStatus}
            mlParams={mlParams}
            onOverlayReady={(value: boolean) => {
              console.log('Making overlayReady true yashxx 203', value);
              setOverlayReady(value);
            }}
            playerSize={playerSize}
            deviceType={deviceType}
          />
        )}

        {(overlayReady || !VideoReady) && (() => {
          const isJPG = streamUrl.split('?')[0].toLowerCase().endsWith('.jpg');

          return isJPG ? (
            <img
              crossOrigin="anonymous"
              ref={imageRef}
              src={streamUrl}
              alt="Stream"
              style={{
                width: `${finalWidth}px`,
                height: `${finalHeight}px`,
                objectFit: 'contain',
                background: 'black',
              }}
            />
          ) : (
            <video
              className={`${isFullscreen ? 'position-absolute react-player' : 'react-player'} ${isRounded && 'rounded-[8px]'}`}
              ref={playerRef}
              src={streamUrl}
              controls={true}
              muted
              autoPlay
              onLoadedData={() => {
                setVideoLoaded(true);
                setTimeout(() => setShowDownloadButton(true), 5000);
              }}
              style={{
                width: `${finalWidth}px`,
                height: `${finalHeight}px`,
                background: 'black',
                objectFit: 'contain',
              }}
            >
              Your browser does not support the video tag.
            </video>
          );
        })()}


        {/* ✅ Always show download button */}
        <button
          onClick={handleCustomDownload}
          style={{
            position: 'absolute',
            bottom: isFullscreen ? '45px' : '30px',
            right: isFullscreen ? '40px' : '7px',
            width: '36px',
            height: '36px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            border: 'none',
            borderRadius: '100%',
            cursor: 'pointer',
            zIndex: 999,
          }}
          title="Download Video"
        >
          <svg width="20" height="20" fill="#5547DD" viewBox="0 0 24 24">
            <path d="M5 20h14v-2H5v2zm7-18v12.17l3.59-3.58L17 13l-5 5-5-5 1.41-1.41L11 14.17V2h2z" />
          </svg>
        </button>

        {/* ✅ Only show play/pause if not a JPG */}
        {!streamUrl.split('?')[0].toLowerCase().endsWith('.jpg') && (
          <button
            onClick={togglePlayPause}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '32px',
              height: '32px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'transparent',
              border: 'none',
              borderRadius: '100%',
              cursor: 'pointer',
              userSelect: 'none',
              zIndex: 20,
            }}
          >
            {internalPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </button>
        )}
      </div>

      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
    </>
  );



};

export default MP4VideoPlayer;

